let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eOPjI")).then(() => parcelRequire('93DJf'));